let Arr = [
    {
        "id": 1,
        "name": "Tic Tac Toe",
        "link": "https://tic-tac-toe-game-using-javascript.vercel.app/",
        "img": "./images/tictactoe.png",
        "repo": "https://github.com/AdityaGoel0320/Tic-Tac_Toe-game-using-javascript"
    },
    {
        "id": 2,
        "name": "Rock Paper Scissor",
        "link": "https://rock-paper-scissor-game-using-javascript.vercel.app/",
        "img": "./images/rockpaperscissor.png",
        "repo": "https://github.com/AdityaGoel0320/Rock-Paper-Scissor-game-using-javascript"

    },
    {
        "id": 3,
        "name": "Word Guessing",
        "link": "https://word-guessing-game-using-javascript.vercel.app/",
        "img": "./images/wordguessing.png",
        "repo": "https://github.com/AdityaGoel0320/Word-Guessing-Game-using-javascript"
    },

]

export default Arr





